import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AuthHeading, AuthLayout } from "../features/auth/components/auth-layout";
import { ResetPasswordForm } from "../features/auth/components/password-forms";

export const Route = createFileRoute("/reset-password")({
  validateSearch: z.object({ token: z.string().optional() }),
  component: () => (
    <AuthLayout>
      <AuthHeading title="Choose a new password" />
      <ResetPasswordForm token={Route.useSearch().token ?? ""} />
    </AuthLayout>
  ),
});
